import React from "react"
import "./styles.scss"

const renderSubList = (subList, className) => {
  if (subList) {
    return (
      <ul>
        {subList.map((subPoint, ind) => (<li key={ind} className={className}>
          {subPoint.text}
          {
            subPoint.footnote && <sup>{subPoint.footnote}</sup>
          }
        </li>))}
      </ul>
    )
  }
}

export const FeaturesAndBenefits = ({ data, buildABand }) => {
  return (
    <>
      {/* <h2 className="my-0">Features and Benefits</h2> */}
      <ul className="features-and-benefits">
        {data?.map((point, ind) => {
          return (
            <div key={ind}>
              {
                point.header ? (
                  <>
                    <h5 className="mt-2">{point.header}</h5>
                    {renderSubList(point.subList, 'my-1')}
                  </>
                )
                  :
                  (
                    <>
                      <li className="mt-1 mb-3">
                        {point.caption &&
                          <> <b>{point.caption}</b>
                            &mdash;
                          </>
                        }
                        {point.text}
                        {point.footnote && <sup>{point.footnote}</sup>}
                      </li>
                      {renderSubList(point.subList, 'my-1')}
                    </>
                  )
              }
            </div>
          )
        })}
        {
          buildABand &&
          (
            <li>
              <a href="https://res.cloudinary.com/dthskrjhy/image/upload/v1643047440/Typenex/new-website-images/Build_a_Band_-_AN-0001-012.2_Editable.pdf">Build-A-Band:&nbsp;</a>
              Don't see what you need? Send us your specification requirements and our team will respond with a quote.
            </li>
          )
        }
      </ul>
    </>
  )
}

export default FeaturesAndBenefits